import { matchPath } from "react-router-dom";
import { getActiveOrgId } from "@piiqtechnologies/ui-lib";
import { buildOrgPath, PATHS } from "@constants/Paths";
/** Pages that moved under `/o/:orgId`. Links saved before the move still point at these. */
const LEGACY_PATHS = [
    PATHS.HOME,
    PATHS.REPORT_TYPE,
    PATHS.CHECKOUT,
    PATHS.OVERVIEW,
    PATHS.RESULTS,
    PATHS.COMMUNITY,
    PATHS.REPORT_SETTINGS,
    PATHS.REPORT_SETTINGS_TOPICS,
    PATHS.REPORT_SETTINGS_COMPETITORS,
    PATHS.NEW_REPORT,
    PATHS.PLANS_BILLING,
    PATHS.ACCOUNT_SETTINGS,
];
/** Old `/home?view=` panels and the pages that replaced them. */
const HOME_VIEWS = {
    "plans-billing": { path: PATHS.PLANS_BILLING },
    "account-settings": { path: PATHS.ACCOUNT_SETTINGS },
    "report-types": { path: PATHS.PLANS_BILLING, view: "report-types" },
    checkout: { path: PATHS.PLANS_BILLING, view: "checkout" },
};
export const isLegacyPath = (pathname) => LEGACY_PATHS.some((path) => matchPath(path, pathname));
/** The org-relative path an old link names, with any old `/home?view=` panel mapped to its page. */
export const toOrgRelativePath = (pathname, search, hash) => {
    var _a;
    const params = new URLSearchParams(search);
    params.delete("org");
    let path = pathname;
    const homeView = pathname === PATHS.HOME ? HOME_VIEWS[(_a = params.get("view")) !== null && _a !== void 0 ? _a : ""] : undefined;
    if (homeView) {
        path = homeView.path;
        params.delete("view");
        if (homeView.view)
            params.set("view", homeView.view);
    }
    const query = params.toString();
    return `${path}${query ? `?${query}` : ""}${hash}`;
};
/**
 * Where an old, unprefixed link should go, or `null` when the path isn't one. Into the active
 * organization when there is one; otherwise to Select Organization, which picks the organization
 * (automatically when there is only one) and then opens the same page.
 */
export const getLegacyRedirect = (pathname, search, hash) => {
    if (!isLegacyPath(pathname))
        return null;
    const path = toOrgRelativePath(pathname, search, hash);
    const activeOrgId = getActiveOrgId();
    if (activeOrgId)
        return { to: buildOrgPath(activeOrgId, path) };
    return { to: PATHS.SELECT_ORGANIZATION, state: { redirectTo: path } };
};
/** An internal path, so a redirect target carried in state can't send anyone off the site. */
export const isSafeRedirect = (value) => typeof value === "string" && value.startsWith("/") && !value.startsWith("//");
